import React, { useContext, useEffect } from "react";
import "../TechApp/TechApp.css";
import Sidebar from "../TechApp/Menu/Sidebar.jsx";
import { useLocation } from "react-router-dom";
import MobileMenu from "../TechApp/Menu/MobileMenu.jsx";
import { useSelector, useDispatch } from "react-redux";
import { techappContext } from "../Api/techappReq";
import { Spin } from "antd";
import useTicket from "../hooks/useTicket";
import { setShowUnread } from "../Redux/Actions/TechAppAction";
import useApp from "../hooks/useApp.js";

const Layout = ({ children }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const profileData = useSelector((state) => state.TechAppReducer.profileData);
  const hints = useSelector((state) => state.TechAppReducer.hints);
  const { profile, getBadgesReq, getSettings } = useContext(techappContext);
  const { getHints } = useApp();
  const { getUnreadAnnouncements, getUnreadTickets } = useTicket();

  const settings = useSelector((state) => state.TechAppReducer.settings);
  const numMandatoryPopups = settings?.technician_app_mandatory_popups ?? 3;

  useEffect(() => {
    getSettings();
    profile();
    getBadgesReq();
    getUnreadTickets();
    if (hints.length === 0) {
      getHints();
    }
  }, []);

  useEffect(() => {
    if (settings) {
      getUnreadAnnouncements("training", 1, numMandatoryPopups);
      getUnreadAnnouncements("public", 1, numMandatoryPopups);
      getUnreadAnnouncements("private", 1, numMandatoryPopups);
    }
  }, [settings]);

  useEffect(() => {
    if (location.pathname === "/techapp") {
      dispatch(setShowUnread(true));
    } else {
      dispatch(setShowUnread(false));
    }
  }, [location.pathname]);

  return (
    <>
      {profileData ? (
        <div className="tech-app">
          <div>
            <Sidebar />
          </div>
          <div className="tech-app-body">{children}</div>
          <MobileMenu />
        </div>
      ) : (
        <div className="loading-wrapper">
          <Spin size="large" />
        </div>
      )}
    </>
  );
};
export default Layout;
